import React from 'react';
import PropTypes from 'prop-types';
import GatsbyImg from 'gatsby-core-theme/src/hooks/gatsby-img';

import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus-box/template-one';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/operator-cta';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';

import { TrackingKeys } from '~constants/tracking-api';

import { imagePrettyUrl, getAltText } from '~helpers/getters';
import PrettyLink from '~atoms/pretty-link';
import styles from './row.module.scss';

const Variable = ({
  toplist,
  tracker,
  oneliner,
  pageTemplate,
  moduleName = TrackingKeys?.HEADER?.TOPLIST,
  icon,
}) => {
  let { items } = toplist;

  items = items?.filter((res) => res.status === 'active');

  const itemsToShow = items?.slice(0, 2);

  const trackerType = tracker.toLowerCase().replace(' ', '_');

  const itemNode = itemsToShow?.map((item, index) => {
    const { ribbons } = item;
    const hasRibbon = ribbons && ribbons.length > 0;
    const campaignImage = item?.extra_fields?.campaign_image;
    const itemName = item?.name || item?.relation?.name;

    return (
      <li
        className={`${styles.li || ''} ${hasRibbon ? styles.hasRibbonIncluded : ''}`}
        data-rank={index + 1}
      >
        <div className={styles.topSection}>
          <PrettyLink
            operator={item}
            pageTemplate={pageTemplate}
            clickedElement="campaign-image"
            tracker={trackerType}
            className={styles.campaignImageContainer}
          >
            {campaignImage ? (
              <LazyImage
                src={imagePrettyUrl(
                  `${campaignImage.filename}${campaignImage.extension}`,
                  816,
                  302
                )}
                alt={getAltText(campaignImage)}
                width={406}
                height={154}
                className={styles.campaignImage}
              />
            ) : (
              <GatsbyImg
                alt="Default Image"
                width="100%"
                height={104}
                className={styles.campaignImageDef}
                filename="campaign_image.png"
              />
            )}
            <LazyImage
              alt={item?.name}
              loading="eager"
              width={168}
              height={168}
              src={imagePrettyUrl(item?.logo?.filename, 168, 168)}
              className={styles.bonusOperatorlogo}
            />
          </PrettyLink>
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.operatorDetails}>
            {itemName}
            <StarRating numOfStars={5} rating={item?.rating} showDecimal />
          </div>

          <div className={styles?.bonusModule}>
            <Bonus
              titleSuffix="Bonus"
              item={item}
              tracker={oneliner}
              moduleName={moduleName}
              pageTemplate={pageTemplate}
              itemPosition={index + 1}
            />
            <span className={styles?.ctaAndReview || ''}>
              <OperatorCta
                operator={item}
                tracker={tracker}
                moduleName={moduleName}
                pageTemplate={pageTemplate}
                gtmClass="toplist-operator-cta-gtm"
                buttonSize="m"
                buttonType="primary"
                titleSuffix={item.name}
                itemPosition={index + 1}
                icon={icon}
              />
            </span>
          </div>
        </div>
        <div className={styles.tnc}>
          <Tnc isFixed operator={item} />
        </div>
        {hasRibbon && <span className={styles.ribbon}>{ribbons[0]}</span>}
      </li>
    );
  });
  return <>{itemNode}</>;
};

Variable.propTypes = {
  moduleName: PropTypes.string,

  toplist: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        rating: PropTypes.string,
        status: PropTypes.string,
        extra_fields: PropTypes.shape({
          campaign_image_object: PropTypes.shape({}),
        }),
        relation: PropTypes.shape({
          name: PropTypes.string,
          rating: PropTypes.string,
          status: PropTypes.string,
        }),
      })
    ).isRequired,
  }).isRequired,

  tracker: PropTypes.string,
  oneliner: PropTypes.string,
  pageTemplate: PropTypes.string,
  icon: PropTypes.element,
};

export default Variable;
